import { render, staticRenderFns } from "./ShippingLabelsViewer.vue?vue&type=template&id=64dfd180&"
import script from "./ShippingLabelsViewer.vue?vue&type=script&lang=js&"
export * from "./ShippingLabelsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports